import { useContext, useRef } from 'react'

import { PageLimit } from '@procurify/ui'
import { nanoid } from 'nanoid'

import { usePagination } from '@webapp/core/hooks/usePagination'
import { type PaginationID } from '@webapp/core/providers/Pagination/pagination.types'
import { PaginationControlsContext } from '@webapp/core/providers/Pagination/PaginationControlsContext'

const DEFAULT_PAGE_SIZE = 10
export interface IPaginationPageLimitProps {
  id?: PaginationID
}

export const PaginationPageLimit = ({
  id: idOverride,
}: IPaginationPageLimitProps) => {
  const { id } = useContext(PaginationControlsContext)

  const paginationId = idOverride || id

  if (!paginationId) {
    throw new Error(
      'PaginationPage must be used within a PaginationControls context or provide an id prop'
    )
  }

  const {
    params: { pageSize },
    updateParams,
  } = usePagination({
    id: paginationId,
  })
  const inputIdRef = useRef(`${paginationId}-page-limit-${nanoid(10)}`)

  const onPageLimitChange = ({ value }: { value: string }) => {
    updateParams({ page: 1, pageSize: parseInt(value, 10) })
  }

  const formattedPageSize = pageSize
    ? pageSize.toString()
    : DEFAULT_PAGE_SIZE.toString()

  return (
    <PageLimit
      inputId={inputIdRef.current}
      onChange={onPageLimitChange}
      value={{ value: formattedPageSize, label: formattedPageSize }}
    />
  )
}
